module.exports = __webpack_public_path__ + "static/media/mental.2887fe1e.svg";